module.exports = __webpack_public_path__ + "img/9.087d895e.jpg";